<app-integration
    [widgetRef]="widgetRef"
    [integrationInput]="integrationInput"
    [isConfigured]="isConfigured"
    (onIntegrate)="onIntegrate()"
    [description]="widgetRef.widgetDescription"
></app-integration>
